import { Pipe, PipeTransform } from '@angular/core';
import * as dayjs from 'dayjs';
import * as timezone from 'dayjs/plugin/timezone';
import * as utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

@Pipe({
  name: 'utcDate',
})
export class UtcDatePipe implements PipeTransform {
  constructor() {}

  transform(value: string | Date | null | undefined, format: string = 'MM/DD/YYYY'): string {
    if (!value) {
      return '—';
    }

    let dayjsObj: dayjs.Dayjs;

    if (typeof value === 'string') {
      if (value.endsWith('Z')) {
        dayjsObj = dayjs.utc(value);
      } else {
        dayjsObj = dayjs(value).utc();
      }
    } else if (value instanceof Date) {
      dayjsObj = dayjs(value).utc();
    } else {
      return '—';
    }

    return dayjsObj.format(format.toUpperCase()) || '—';
  }
}
